export default Object.freeze({
  DESC: 'Plus récente',
  ASC: 'Plus ancienne',
});
